module.exports = __webpack_public_path__ + "static/media/5.28b2f761.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格选中态/5.png
// module id = 1277
// module chunks = 0